import src from "IMAGE";
export default { src, width: 1188, height: 482, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARElEQVR42i3KQQoAIAgEQImILtWhS+DHfJJv8CS+NBc8DOjuUkTMtNNNr9zKJqlqd3eMVjplIUNHzEwi0vCY2QDcyNB9nuMoIcgIs9EAAAAASUVORK5CYII="};
